import { HttpErrorResponse } from "@angular/common/http";
import { EditOrganisationDto, Organisation, OrganisationDTO, OrganisationDetails, OrganisationPermissionsLabelDto } from "src/app/_models/Organisation";
import { OrganisationRecord } from "src/app/_models/OrganisationRecord";

export interface OrganisationState {
  loading: boolean;
  list: Organisation[];
  error: any;

  organisationRecords: OrganisationRecord[];
  organisationRecordsLength: number;

  isInitialLoadFlowReset: boolean;
  isGetTableOverallLength: boolean;

  crudData: OrganisationDTO;
  crudLoader: boolean;
  crudResult: Organisation;
  crudError: any;

  editOrgData: EditOrganisationDto;

  validOrgName: boolean | null;
  orgNameLoader: boolean;
  orgNameError: any;

  organisationDetails: OrganisationDetails;

  organisationPermissions: OrganisationPermissionsLabelDto[];

  isOrgDeletable: boolean | null;
  isOrgDeletableLoader: boolean;
  isOrgDeletableError: HttpErrorResponse;

  deleteOrganisationLoader: boolean;
  deleteOrganisationResult: boolean | null;
  deleteOrganisationError: HttpErrorResponse;
}

export const initialOrganisationState: OrganisationState = {
  loading: false,
  list: [],
  error: null,

  organisationRecords: [],
  organisationRecordsLength: 0,

  isInitialLoadFlowReset: false,
  isGetTableOverallLength: false,

  crudData: null,
  crudLoader: false,
  crudResult: null,
  crudError: null,

  editOrgData: null,

  validOrgName: null,
  orgNameLoader: false,
  orgNameError: null,

  organisationDetails: null,

  organisationPermissions: null,

  isOrgDeletable: null,
  isOrgDeletableLoader: false,
  isOrgDeletableError: null,

  deleteOrganisationLoader: false,
  deleteOrganisationResult: null,
  deleteOrganisationError: null
};
